module.exports = __webpack_public_path__ + "img/head.e1f8f5e0.png";